const browserOrigin = () =>
  typeof window === "undefined" ? "" : window.location.origin;

export const isAdminHost = () =>
  typeof window !== "undefined" &&
  window.location.hostname.toLowerCase() === "admin.veristrata.ai";

export const adminOrigin = () => {
  const configured = import.meta.env.VITE_ADMIN_ORIGIN?.replace(/\/$/, "");
  if (configured) return configured;
  if (import.meta.env.PROD) return "https://admin.veristrata.ai";
  return browserOrigin();
};

export const appOrigin = () => {
  const configured = import.meta.env.VITE_APP_ORIGIN?.replace(/\/$/, "");
  if (configured) return configured;
  if (isAdminHost()) return "https://veristrata.ai";
  return browserOrigin();
};

export const adminUrl = (path = "/admin") =>
  `${adminOrigin()}${path.startsWith("/") ? path : `/${path}`}`;

export const appUrl = (path = "/") =>
  `${appOrigin()}${path.startsWith("/") ? path : `/${path}`}`;
